import { useQuery, UseQueryResult } from '@tanstack/react-query';
import axios from 'lib/axios';

export const useContentGroup = (id: string): UseQueryResult<any[]> => {
	return useQuery({
		queryKey: ['contentGroup', id],
		queryFn: async() => {
			const { data: { contentGroup } } = await axios.get(`/content-groups/${id}`);
      return contentGroup;
		}
	});
};